<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24"
        ><Breadcrumbs :arr="['碳汇管理平台', '碳汇+义务植树']"
      /></el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input
              size="small"
              v-model="search.planterName"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              size="small"
              v-model="search.phone"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="植树状态">
            <el-select v-model="search.plantingStatus" clearable placeholder="请选择" size="small">
              <el-option label="未种植" :value="0"> </el-option>
              <el-option label="已种植" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item id="time" label="日期">
            <el-date-picker
            v-model="search.payTimeStart"
            type="date"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear"
            style="width: 200px"
            placeholder="开始日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker
            v-model="search.payTimeEnd"
            type="date"
            size="small"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear1"
            value-format="yyyy-MM-dd"
            style="width: 200px"
            placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">

            <el-button size="small" type="primary" @click="getList" round
              >查询</el-button
            >
            <el-button
              size="small"
              style="margin: 0 0 0 50px"
              @click="reset"
              round
              type="info"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn">
          <!-- class="theme-btn" -->
          <el-button size="small" type="primary" @click="isExport()" round>导出</el-button>
          <el-button size="small" type="primary" @click="isAddData(null,false,false)" round
            >批量上传</el-button>
        </div>
        <Tables
          class="table"
          :columns="columns"
          :loading="loading"
          :tableData="tableData"
          ref="tableBox"
        >
 

          <template #plantingStatus="scope">
           <div>{{changeType(scope.row.plantingStatus)}}</div>
          </template>
          <template #accessory="scope">
            <div class="operation" v-for="(item, index) in scope.row.accessory" :key="item.id">
              <a class="color pointer" :href="item.url" target="_blank">
              <img style="height: 30px;" :src="item.url">
              </a>
 
            </div>
          </template>
          <template #actions="scope">
            <div class="flex">
              <el-button type="text" @click="isEdit(scope.row,true)" :disabled="scope.row.plantingStatus==1"
                >上传</el-button
              >
              <el-button type="text" @click="isEdit(scope.row,true)" :disabled="scope.row.plantingStatus==0"
                >修改</el-button
              >
              <el-button type="text" @click="isView(scope.row)"
                >详情</el-button
              >
            </div>
          </template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
    
    <modaDialogl
      :dialog="dialog"
      :formData="formData"
      :handleClose="handleClose"
      :isView="isShowView"
      :singleEditing="singleEditing"
    />
    <el-dialog title="导出" :visible.sync="dialogVisible" width="40%" :before-close="handleCloseExport">
      <el-form ref="form" :inline="true" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item id="time" label="选择日期" prop="payTimeStart" class="inlinitem">
          <el-date-picker v-model="form.payTimeStart" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" placeholder="开始日期" :picker-options="pickerOptions3">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="inlinitem" prop="payTimeEnd">
          <el-date-picker v-model="form.payTimeEnd" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            style="width: 200px" :picker-options="pickerOptions4" placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitExport">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getTreeList,
  treeExport
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import modaDialogl from "./components/modaDialogl.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "policyInformation",
  data() {
    return {
      singleEditing:false,
      search: {
        planterName: "",
        phone: "",
        plantingStatus:'',
        payTimeStart:"",
        payTimeEnd:"",
      },
      pickerOptionsYear: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.payTimeStart);
          const end = Date.parse(this.search.payTimeEnd);
          if (this.search.payTimeEnd) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsYear1: {
          disabledDate: (time) => {
            const start = Date.parse(this.search.payTimeStart);
            const end = Date.parse(this.search.payTimeEnd);
            if (this.search.payTimeStart) {
              return (
                time.getTime() < start - 8.64e7
              );
            } else {
              // return time.getTime() > Date.now();
            }
          },
      },
      // 表格展示数据
      tableData: [],
      // 表格显示标题
      columns: [],
      loading: false,
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 是否显示操作按钮
      isShowView: true,
      // 表单信息
      formData: {},
      // 导出的弹出
      dialogVisible: false,
      // 校验
      rules: {
        payTimeStart: [{ required: true, message: "选择开始日期" }],
        payTimeEnd: [{ required: true, message: "选择结束日期" }],
      },
      // 导出的日期表单
      form: {
        payTimeStart: "",
        payTimeEnd: "",
      },
      pickerOptions3: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.payTimeStart);
          const end = Date.parse(this.form.payTimeEnd);
          if (this.form.payTimeEnd) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions4: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.payTimeStart);
          const end = Date.parse(this.form.payTimeEnd);
          if (this.form.payTimeStart) {
            return (
              time.getTime() < start - 1000 * 60 * 60 * 24
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
      // 导出文件名
      fileName: "",
      excel: ''
    };
  },
  watch: {
    tableData(newval, oldval) {
			if (newval) {
        const than=this
				than.$nextTick(() => {
          console.log(than.$refs,'than.$refs')
					than.$refs.tableBox.$children[0].doLayout()
				})
			}
		  }
		},
  methods: {
    // 页面初始化
    init() {
      this.columns = columns;
      this.getList();
    },
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      let search={...this.search}
      if(search.payTimeStart){
        search.payTimeStart=search.payTimeStart+' 00:00:00'
      }
      if(search.payTimeEnd){
        search.payTimeEnd=search.payTimeEnd+' 23:59:59'
      }
      getTreeList(search, page).then((res) => {
        if (res.data.code == "200") {
          this.tableData = res.data.data.records;
          this.pageData.total = res.data.data.total;
          this.tableData.forEach((item) => {
            item.accessory = item.accessory ? JSON.parse(item.accessory) : [];
          });
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search = {
        planterName: "",
        phone: "",
        plantingStatus:'',
        payTimeStart:"",
        payTimeEnd:"",
      };
      this.getList();
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false;
    },
    // 新增
    isAddData(form,singleEditing) {
      this.singleEditing=singleEditing
      this.formData = {
        payTimeStart: "", // 开始时间
        payTimeEnd: "", // 结束时间
        accessory:"",//附件
        treeName:"",//植树名称
        summary:''//植树介绍
      };
      this.dialog.visible = true;
      this.isShowView = true;
      this.dialog.title = "新增";
    },
    // 修改
    async isEdit(form,singleEditing) {
      this.singleEditing=singleEditing
      this.formData = {...form};
      this.dialog.visible = true;
      this.dialog.title = "修改";
      this.isShowView = true;
    },
    // 详情
    async isView(form) {
      this.singleEditing=true
        this.formData = {...form};
        this.dialog.visible = true;
        this.dialog.title = "详情";
        this.isShowView = false;
      
    },


    // 切换条数
    sizeChange(val){
        this.pageData.size = val
        this.getList()
    },
    // 切换页数
    currentChange(val){
        this.pageData.page = val
        this.getList()
    },
    //导出
    isExport() {
      this.dialogVisible = true;
      this.fileName = ""
      this.form.payTimeStart = ""
      this.form.payTimeEnd = ""
      this.$nextTick(()=>{
        this.$refs["form"].resetFields();
      })
    },
    // 导出弹出窗关闭
    handleCloseExport(done) {
      this.dialogVisible = false;
    },
    // 导出的提交
    async submitExport() {
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
          this.fileName = "碳汇+义务植树"
          let form={...this.form}
          form.payTimeStart=form.payTimeStart+' 00:00:00'
          form.payTimeEnd=form.payTimeEnd+' 23:59:59'
          const res = await treeExport(form)
          console.log(res)
          console.log(res.data)
          if (res.data.type == "application/vnd.ms-excel") {
            console.log(res)
            console.log(res.data)
            this.excel = res.headers['content-disposition']
            this.$message.success("导出成功");
            this.downloadFileExcel(res, this.fileName)
            this.excel = ""
            this.fileName = ""
            this.form.payTimeStart = ""
            this.form.payTimeEnd = ""
            this.dialogVisible = false
          } else this.$message.error("筛选范围暂无数据");
      }




    },
    // 下载的方法
    downloadFileExcel(response, fileName) {
      const headers = response.headers;
      const contentType = headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const temp = response.headers['content-disposition'];
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(temp);
      let fileType = '';
      if (matches != null && matches[1]) {
        fileType = matches['input'].substring(matches['input'].lastIndexOf('.'));
      }
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName + fileType; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    // 通过类型返回文字
    changeType(type) {
      if (type == 0) return '未种植'
      else if (type == 1) return '已种植'
      else return ''
    },
    setUrl(arr){
      arr = JSON.parse(arr)
      if(arr.length)
        return arr[0].url
      else return ''
    },
    downloadFile(fileBase64) {
      // 将Base64编码转换为Blob对象
      const byteCharacters = atob(fileBase64.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/octet-stream' });

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = '图片.png';
      a.click();

      // 释放URL对象
      window.URL.revokeObjectURL(url);
    }
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    modaDialogl,
    Paginations,
  },
};
</script>
<style scoped>

.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.operation{
  color: #409EFF;
}
</style>
